export default function Footer() {
  return (
    <footer className="bg-gray-950 border-t border-gray-800 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold text-orange-500 mb-4">
              CONPR<span className="logo-o-bounce">O</span>
            </h3>
            <p className="text-gray-400 text-sm">
              Building digital excellence through innovative construction and development solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="#about" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">About Us</a></li>
              <li><a href="#services" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">Services</a></li>
              <li><a href="#projects" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">Projects</a></li>
              <li><a href="#contact" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">Contact</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li><span className="text-gray-400 text-sm">Commercial Construction</span></li>
              <li><span className="text-gray-400 text-sm">Residential Development</span></li>
              <li><span className="text-gray-400 text-sm">Project Management</span></li>
              <li><span className="text-gray-400 text-sm">Design & Planning</span></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact Info</h4>
            <ul className="space-y-2">
              <li className="flex items-center text-gray-400 text-sm">
                <i className="ri-phone-line mr-2 text-orange-500"></i>
                +34 664 428 424
              </li>
              <li className="flex items-center text-gray-400 text-sm">
                <i className="ri-mail-line mr-2 text-orange-500"></i>
                conproevolucionsl@gmail.com
              </li>
              <li className="flex items-center text-gray-400 text-sm">
                <i className="ri-map-pin-line mr-2 text-orange-500"></i>
                Avda Virgen del Rocío 1, 29670, Marbella (Málaga), Spain
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © 2025 CONPRO. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">Privacy Policy</a>
            <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}